import axios from "axios";
import { AuthContextValue } from "@/contexts/auth";
import { API_PREFIX } from "@/constants";
import { SOP } from "../../constants";
// import { SendEntity } from "./constants";

// export type EntityListResult = {
// data: SendEntity[];
// current: number;
// pageSize: number;
// total: number;
// };

export const queryEntityList = async (
  id: SOP["id"],
  auth: AuthContextValue
) => {
  const res = await axios.get(
    `${API_PREFIX.WEB}/sop/task/customer/list/${id}`,
    {
      params: { ...auth },
    }
  );
  if (res && res.data) {
    return res.data;
  }
  // if (pagination.current === 1) {
  //   return {
  //     data: [
  //       {
  //         userId: 'janson',
  //         entityId: 'wmnTrwEAAAzpqJZBMIgAV0P2wsNvLU3w',
  //         entityName: 'JansonJansonJansonJansonJanson',
  //         avatar: 'http://wx.qlogo.cn/mmhead/Q3auHgzwzM7oEJAVQ9MuYD5DLYEP4Qic2hyolib5W4Uic2P5RFPs5PicKg/0',
  //         entityType: EntityType.CUSTOMER,
  //         actionStatus: ActionStatus.UN_SEND,
  //         actionMessage: ActionMessage.HAS_NO_DELIVERY,
  //         sopSendType: SOPSendType.DAY,
  //         executeTime: '2021年10月26日 16:32:10'
  //       },
  //       {
  //         userId: 'XiZiRenSheng@l',
  //         entityId: 'wrnTrwEAAAfedQdhaikrGlN_ATiCYIBw',
  //         entityName: '测试客户群聊',
  //         avatar: '',
  //         entityType: EntityType.GROUP,
  //         actionStatus: ActionStatus.SEND_SUCCESS,
  //         actionMessage: ActionMessage.HAS_DELIVERY,
  //         sopSendType: SOPSendType.DAY,
  //         executeTime: '2021年10月26日 16:32:10'
  //       }
  //     ] as SendEntity[],
  //     current: 1,
  //     pageSize: 2,
  //     total: 3
  //   };
  // } else {
  //   return {
  //     data: [
  //       {
  //         userId: 'jgfhjfgh',
  //         entityId: 'asdagh dfgtufxg',
  //         entityName: '客户3',
  //         avatar: '',
  //         entityType: EntityType.CUSTOMER,
  //         actionStatus: ActionStatus.UN_SEND,
  //         actionMessage: ActionMessage.HAS_NO_DELIVERY,
  //         sopSendType: SOPSendType.WEEK,
  //         executeTime: '2021年10月26日 16:32:10'
  //       }
  //     ] as SendEntity[],
  //     current: 2,
  //     pageSize: 2,
  //     total: 3
  //   }
  // }
};
